import { styled } from 'styled-components';

export const ImageCarouselItemContainer = styled.div`
  flex: 0 0 100%;
`;

export const ImageCarouselImage = styled.img`
  height: 100%;
  width: 100%;
  /* object-fit: contain; */
  /* object-fit: cover; */
`;
